export default __webpack_public_path__ + "static/media/longchamp33.eb676ecc.jpg";